import React, { useContext, useState } from 'react';
import notecontext from "../context/notes/Notecontext";

export default function Addnote() {
  const context = useContext(notecontext);
  const { addnote } = context;
  const [note, setnote] = useState({ title: "", description: "", tag: "" });

  const handleclick = (e) => {
    e.preventDefault();
    addnote(note.title, note.description, note.tag);
    setnote({title: "", description: "", tag: ""})
    alert("Note added successfully!");
  };

  const onchange = (e) => {
    setnote({ ...note, [e.target.name]: e.target.value });
  };

  return (
    <div className="container my-4 p-4 bg-white rounded shadow-sm">
      <h2 className="mb-3 text-center" style={{color:'#3730a3'}}>Add a New Note</h2>
      <form>
        <div className="mb-3">
          <label htmlFor="title" className="form-label">Title</label>
          <input type="text" className="form-control" name='title' id="title" aria-describedby="emailHelp" value={note.title} onChange={onchange} minLength={5} required  />
        </div>
        <div className="mb-3">
          <label htmlFor="description" className="form-label">Description</label>
          <input type="text" className="form-control" id="description" name='description' onChange={onchange} value={note.description}  minLength={5} required />
        </div>
        <div className="mb-3">
          <label htmlFor="tag" className="form-label">Tag</label>
          <input type="text" className="form-control" id="tag" name='tag' onChange={onchange} value={note.tag}  minLength={5} required />
        </div>
        <button type="submit" disabled={note.title.length<5 || note.description.length<5} className="btn btn-primary w-100 py-2" onClick={handleclick}>Add Note</button>
      </form>
    </div>
  );
}
